// src/pages/TplinkSmartPlugs.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TplinkSmartPlugs() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Tapo Smart Plugs | TP-Link | SeguraTech</title>
        <meta
          name="description"
          content="Learn how TP-Link Tapo Smart Plugs bring intelligent control, automation, and energy efficiency to your home with Alexa, Google, and Matter compatibility."
        />
        <meta property="og:title" content="Tapo Smart Plugs | TP-Link | SeguraTech" />
        <meta
          property="og:description"
          content="TP-Link Tapo Smart Plugs offer smart scheduling, voice control, and real-time energy monitoring for a more efficient home."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seguratech.co.uk/tplink/smart-plugs" />
        <meta property="og:image" content="/tplink-logo.png" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-5xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-6">
          Tapo Smart Plugs
        </h1>
        <p className="text-lg text-white/80 max-w-3xl mx-auto">
          TP-Link Tapo Smart Plugs give you complete control over connected
          appliances using your voice, phone, or automation schedules. Simple,
          discreet, and energy-efficient, they make your everyday devices
          instantly smarter.
        </p>
      </section>

      {/* Feature Boxes */}
      <section className="max-w-6xl mx-auto px-4 pb-24 grid md:grid-cols-2 gap-10">
        {/* Box 1: Smart Scheduling */}
        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition flex flex-col justify-between">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-4 text-center">
            Smart Scheduling
          </h3>
          <p className="text-white/80 text-center leading-relaxed">
            Create custom on and off times for any connected device.
            Automate lamps, heaters, and appliances to match your daily
            routines and reduce unnecessary power use.
          </p>
        </div>

        {/* Box 2: Energy Monitoring */}
        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition flex flex-col justify-between">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-4 text-center">
            Energy Monitoring
          </h3>
          <p className="text-white/80 text-center leading-relaxed">
            Track your energy use in real time with the Tapo app.
            Identify which devices consume the most power and take
            control of your energy bills with simple automation.
          </p>
        </div>
      </section>

      {/* Info Section */}
      <section className="max-w-4xl mx-auto px-4 pb-16 text-center text-white/80 leading-relaxed">
        <p className="mb-6">
          Tapo Smart Plugs connect directly to Wi-Fi and support voice
          control through Amazon Alexa and Google Assistant. With Matter
          compatibility, they integrate seamlessly into any smart home
          ecosystem. Each plug is compact, easy to set up, and built to
          operate reliably over time without added hubs or complexity.
        </p>
        <p>
          Use them to control lighting, manage standby power, or switch
          off hard-to-reach sockets. Smart plugs are an easy first step
          toward efficient, intelligent home automation that fits your
          lifestyle.
        </p>
      </section>

      {/* Back Link */}
      <div className="text-center pb-16">
        <Link
          to="/tplink/tapo-power"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to Smart Power Overview
        </Link>
      </div>
    </div>
  );
}
